import Datetime from './datetime.vue'

let Plugin = {},
    vueInstance;

Plugin.install = function (Vue, opt) {
    opt.root.datetime = function () {
        // if (!vueInstance) {
        let el = document.createElement('div')
        document.querySelector('body').appendChild(el)

        let vueClass = Vue.extend(Datetime);

        vueInstance = new vueClass({
            el: el,
            router: opt.router
        })
        // }

        vueInstance.wrapshow = true
        return vueInstance.showPicker(...arguments)
    }
}


export default Plugin;
